import { render, staticRenderFns } from "./OnboardingError.vue?vue&type=template&id=082260f5&scoped=true"
import script from "./OnboardingError.vue?vue&type=script&lang=js"
export * from "./OnboardingError.vue?vue&type=script&lang=js"
import style0 from "./OnboardingError.vue?vue&type=style&index=0&id=082260f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082260f5",
  null
  
)

export default component.exports